import { uid } from '../../../../lib/uid';

/**
 * Test data backing the Autogenerate button on the repository folder form.
 *
 * Fills every required field so the primary action enables on the first try, and the optional
 * ones the form can offer a real value for — a folder generated with only its name produces a
 * row that exercises nothing behind it. Keep it in lockstep with the form: a new required
 * field must be added here in the same change, or Autogenerate silently stops working.
 *
 * Values are synthetic vocabulary. A folder name never leaves `rsys_` and never lands in the
 * identity store, so plausible wording is right here — the rule about obviously-fake values
 * is about where a value LANDS, and `samplePersonnel` is the case that governs.
 */

const FOLDER_NAMES = [
  'Policies',
  'Standard Operating Procedures',
  'Templates',
  'Forms',
  'Manuals',
  'Work Instructions',
  'Records',
  'Guidelines',
];

const DESCRIPTIONS = [
  'Controlled documents maintained by the document controller.',
  'Issued documents, reviewed annually.',
  'Reference copies for day-to-day use.',
  'Approved templates drawn on by every unit.',
];

/**
 * One folder.
 *
 * The name carries a suffix because it is unique among the ACTIVE siblings, and Autogenerate
 * is most useful clicked repeatedly — without one the second click would produce a name the
 * server rejects as a duplicate.
 *
 * **The folder code is deliberately left empty.** It is what turns a folder into a
 * controlled-document folder, and it cannot be changed afterwards — so generating one would
 * make the same button produce a materially different kind of folder on each click, which is
 * the unpredictability the flag rule exists to prevent. A reader who wants a coded folder
 * types the code, which is one field.
 */
export function sampleFolder(): { name: string; description: string } {
  const name = FOLDER_NAMES[Math.floor(Math.random() * FOLDER_NAMES.length)];
  const description = DESCRIPTIONS[Math.floor(Math.random() * DESCRIPTIONS.length)];

  return {
    name: `${name} ${uid().slice(0, 6).toLowerCase()}`,
    description,
  };
}
